"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvitationForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Indicators_1 = require("../Indicators");
var react_hook_form_1 = require("react-hook-form");
var yup = __importStar(require("yup"));
var yup_1 = require("@hookform/resolvers/yup");
var lodash_1 = require("lodash");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var Form_1 = require("../Form");
var hooks_1 = require("../../hooks");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var clsx_1 = __importDefault(require("clsx"));
var schema = yup.object({
    name: yup.string().required(),
    email: yup.string().email().required(),
    accessLevel: yup.mixed().oneOf(["user", "admin"]).required(),
    canCreate: yup.boolean(),
});
var InvitationForm = function (_a) {
    var externalSubmitHandler = _a.onSubmit, loading = _a.loading, _b = _a.defaultValues, defaultValues = _b === void 0 ? { name: "", email: "", accessLevel: "user" } : _b, _c = _a.submitTitle, submitTitle = _c === void 0 ? "Send Invitation" : _c, className = _a.className;
    var _d = (0, react_hook_form_1.useForm)({
        resolver: (0, yup_1.yupResolver)(schema),
        mode: "onBlur",
    }), formState = _d.formState, handleSubmit = _d.handleSubmit, register = _d.register, formErrors = _d.formState.errors, setError = _d.setError, reset = _d.reset, watch = _d.watch, setValue = _d.setValue;
    (0, hooks_1.useDefaultValueListener)(defaultValues, reset);
    var _e = watch(["accessLevel", "canCreate"]), accessLevel = _e[0], canCreate = _e[1];
    var handleFormSubmit = handleSubmit(function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, errors, keys;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, externalSubmitHandler(__assign(__assign({}, data), { accessLevel: data.accessLevel === "user" && data.canCreate
                            ? "creator"
                            : data.accessLevel }))];
                case 1:
                    _a = ((_b = (_c.sent())) !== null && _b !== void 0 ? _b : {}).errors, errors = _a === void 0 ? {} : _a;
                    keys = Object.keys(errors);
                    keys.length
                        ? keys.map(function (key) {
                            return setError((0, lodash_1.camelCase)(key), {
                                message: errors[key],
                            });
                        })
                        : reset({});
                    return [2 /*return*/];
            }
        });
    }); });
    var handleToggleCanCreate = (0, react_1.useCallback)(function (e) {
        e.preventDefault();
        e.stopPropagation();
        setValue("canCreate", !canCreate);
    }, [canCreate, setValue]);
    return ((0, jsx_runtime_1.jsxs)("form", __assign({ onSubmit: handleFormSubmit, className: (0, clsx_1.default)(className, "relative") }, { children: [(0, jsx_runtime_1.jsxs)(Form_1.Fields, __assign({ register: register, errors: formErrors, grow: true, className: "pb-2" }, { children: [(0, jsx_runtime_1.jsx)(Form_1.TextField, { name: "name", label: "Name", placeholder: "Name", className: "w-full", initiallyFocused: true }, void 0), (0, jsx_runtime_1.jsx)(Form_1.TextField, { name: "email", label: "Email Address", placeholder: "Email Address", className: "w-full" }, void 0), (0, jsx_runtime_1.jsxs)(Form_1.ControlGroup, __assign({ fullWidth: true, shadow: false, grow: true, column: true, name: "accessLevel", label: "role", selected: accessLevel }, { children: [(0, jsx_runtime_1.jsx)(Form_1.RadioCardControl, __assign({ title: "user", value: "user", icon: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { size: "2x", icon: pro_light_svg_icons_1.faUser }, void 0) }, { children: (0, jsx_runtime_1.jsxs)("ul", __assign({ className: "list-disc ml-4" }, { children: [(0, jsx_runtime_1.jsx)("li", { children: "Basic user access limited to 'read only' or 'read/write' existing calendars." }, void 0), (0, jsx_runtime_1.jsx)("li", { children: "Can only create their own calendars if given special permission." }, void 0)] }), void 0) }), void 0), (0, jsx_runtime_1.jsx)(Form_1.RadioCardControl, __assign({ title: "admin", value: "admin", icon: (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { size: "2x", icon: pro_light_svg_icons_1.faUserCircle }, void 0) }, { children: (0, jsx_runtime_1.jsxs)("ul", __assign({ className: "list-disc ml-4" }, { children: [(0, jsx_runtime_1.jsx)("li", { children: "Can manage permissions for all users and calendars in the company" }, void 0), (0, jsx_runtime_1.jsx)("li", { children: "Can read and edit any calendar in the company." }, void 0), (0, jsx_runtime_1.jsx)("li", { children: "Can create or delete any calendar in the company." }, void 0)] }), void 0) }), void 0)] }), void 0), accessLevel === "user" && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row-reverse border rounded border-stone-200 p-4 relative" }, { children: [(0, jsx_runtime_1.jsx)("button", __assign({ className: "absolute inset-0 opacity-0", onClick: handleToggleCanCreate }, { children: "Toggle Create Ability" }), void 0), (0, jsx_runtime_1.jsx)("label", __assign({ htmlFor: "canCreate", className: "block my-auto ml-4" }, { children: "Allow this user to create their own calendars?" }), void 0), (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: canCreate ? pro_solid_svg_icons_1.faCheckSquare : pro_light_svg_icons_1.faSquare, size: "2x", className: (0, clsx_1.default)("mr-4", canCreate ? "text-lochivar-default" : "text-gray-500") }, void 0), (0, jsx_runtime_1.jsx)("input", __assign({ type: "checkbox", className: "my-auto opacity-0 pointer-events-none absolute" }, register === null || register === void 0 ? void 0 : register("canCreate")), void 0)] }), void 0)), (0, jsx_runtime_1.jsx)(Form_1.ErrorList, { errors: formErrors }, void 0), (0, jsx_runtime_1.jsx)(Form_1.Button, __assign({ type: "submit", className: "mt-2 w-full", disabled: !formState.isValid, align: "stretch" }, { children: (0, jsx_runtime_1.jsx)("span", __assign({ className: "m-auto flex" }, { children: submitTitle }), void 0) }), void 0)] }), void 0), loading ? (0, jsx_runtime_1.jsx)(Indicators_1.AbsoluteOverlay, {}, void 0) : null] }), void 0));
};
exports.InvitationForm = InvitationForm;
